import { adjustLumaDelta } from './';

/**
 * Increases the luminance delta of a color and it's background based on its HSV/HSB representation.
 * Conversion from https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion.
 *
 * @param color: string - color to adjust
 * @param background:string - color of the background
 * @param amount:number - amount to adjust the luminance [0, 100]
 * @param useHsl:boolean - use the HSL color space for the transformation. This is currently used by our High Contrast theme.
 */
export const increaseLumaDelta = (color, background, amount, useHsl = false) => {
  return adjustLumaDelta(color, background, amount, false, useHsl);
};
//# sourceMappingURL=increaseLumaDelta.js.map